<template>
    <div v-if="showAllMenu" class="menu_orders">
        <menu_orders_switch
            v-if="showOrdersMenu"
            :key="'menu_orders_switch'"
            @click_switch_button="clickSwitchButton"
        />
        <spinner
            v-if="!showOrdersMenuList"
            :key="'spinner_orders_menu'"
        />
        <div v-if="showOrdersMenuList" class="menu_orders__list">
            <div v-if="!isOrdersList" class="menu_orders__list_container">
                <div class="menu_orders__list_no_orders">
                    {{__t('O.YOU_HAVE_NO_ACTIVE_ORDERS')}}
                </div>
            </div>
            <div v-if="showActiveOrders" class="menu_orders__list_container">
                <menu_orders_list
                    v-if="isNewOrdersList"
                    :key="'menu_orders_list_new'"
                    :titleList="__t('O.NEW')"
                    :listOrders="ordersNewList"
                />
                <menu_orders_list
                    v-if="isInProgresOrdersList"
                    :key="'menu_orders_list_in_progress'"
                    :titleList="__t('O.IN_WORK')"
                    :listOrders="ordersInProgressList"
                />
            </div>
            <div v-if="showArchiveOrders" class="menu_orders__list_container">
                <menu_orders_list
                    v-if="isReadyOrdersList"
                    :key="'menu_orders_list_new'"
                    :titleList="''"
                    :listOrders="ordersReadyList"
                />
            </div>
        </div>
    </div>
</template>

<script>

import menu_orders_switch from "././MenuOrdersSwitch.vue";
import menu_orders_list from "./MenuOrdersList.vue";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import rest_select_list from "../../rest/RestSelectList.vue";
import start_choice_rest from "../../rest/StartChoiceRest.vue";
import Spinner from "../../loader/Spinner.vue";

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "menu_orders",
    props: {
        showOrdersMenu: {
            type: Boolean,
            required: true,
        },
    },
    components: {Spinner, start_choice_rest, rest_select_list, menu_orders_list, menu_orders_switch},
    mixins: [screenSize],
    data() {
        return {
            isActiveSwitch: true,
            isPoolingOrders: true,
        }
    },
    created() {
        this.isStartChoice = this.isStartChoiceRest;
    },
    beforeMount() {
        EventBus.$on('get_orders_pooling', this.poolingOrders);
    },
    beforeUnmount() {
        EventBus.$off('get_orders_pooling');
    },
    methods: {
        poolingOrders(){
            this.isPoolingOrders = false;
        },
        clickSwitchButton(activeOrdersSwitch) {
            if (activeOrdersSwitch) {
                this.isActiveSwitch = true;
                return;
            }
            this.isActiveSwitch = false;
        },
    },
    computed: {
        ...mOrders([
            'ordersNewList',
            'ordersInProgressList',
            'ordersReadyList',
        ]),
        isOrdersList() {
            if (this.ordersNewList.length > 0 || this.ordersInProgressList.length > 0 ||
                this.ordersReadyList.length > 0) {
                return true;
            }
            return false;
        },
        isOrdersNewInProgress() {
            if (this.ordersNewList.length > 0 || this.ordersInProgressList.length > 0) {
                return true;
            }
            return false;
        },
        isOrdersReady() {
            if (this.ordersReadyList.length > 0) {
                return true;
            }
            return false;
        },
        showActiveOrders() {
            if (this.isOrdersNewInProgress && this.isActiveSwitch) {
                return true;
            }
            return false;
        },
        showArchiveOrders() {
            if (this.isOrdersReady && !this.isActiveSwitch) {
                return true;
            }
            return false;
        },
        isNewOrdersList() {
            if (this.ordersNewList.length > 0) {
                return true;
            }
            return false;
        },
        isInProgresOrdersList() {
            if (this.ordersInProgressList.length > 0) {
                return true;
            }
            return false;

        },
        isReadyOrdersList() {
            if (this.ordersReadyList.length > 0) {
                return true;
            }
            return false;
        },
        showAllMenu() {
            if ((this.isMobileScreen && this.showOrdersMenu) || !this.isMobileScreen) {
                return true;
            }
            return false;
        },
        showOrdersMenuList(){
            if(this.showOrdersMenu && !this.isPoolingOrders) {
                return true;
            }
            return false;
        }
    },
}
</script>
